// extracted by mini-css-extract-plugin
export default {"container":"Detail_container__TpstJ","backButtonArea":"Detail_backButtonArea__60zzr","backButton":"Detail_backButton__ZsRkY"};